module.exports = __webpack_public_path__ + "img/barnet-logo.ef89b659.svg";